/** Точечная штриховка матового натяжного потолка в мировой сетке. */
import type { Room } from "@/widgets/plan";
import {
	CEILING_HATCH_COLOR,
	CEILING_HATCH_DOT,
	CEILING_HATCH_STEP,
	ceilingHatchCells,
} from "./ceilingHatchGeometry";

interface Props {
	room: Room;
	clipId: string;
}

export const StretchMatteHatch = ({ room, clipId }: Props) => {
	const dots = ceilingHatchCells(room).flatMap((cell) => [
		{ x: cell.x + CEILING_HATCH_STEP / 4, y: cell.y + CEILING_HATCH_STEP / 4 },
		{ x: cell.x + (CEILING_HATCH_STEP * 3) / 4, y: cell.y + (CEILING_HATCH_STEP * 3) / 4 },
	]);

	return (
		<g clipPath={`url(#${clipId})`} opacity="0.55">
			{dots.map((dot) => (
				<circle
					key={`${dot.x}-${dot.y}`}
					cx={dot.x}
					cy={dot.y}
					r={CEILING_HATCH_DOT}
					fill={CEILING_HATCH_COLOR}
				/>
			))}
		</g>
	);
};
